<template>
    <div id="teams">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <!-- data-sal="slide-up" data-sal-duration="1000" -->
                <div id="first-banner" class="project-add-banner" :style="`background-image: url(${logo_base}${logo});`">
                    <div class="content">
                        <span class="subtitle primary bold">¡Hagamos Equipo!</span>
                        <h3 class="font-weight-100 white">
                            <slot name="title"></slot>
                        </h3>
                        <h6 class="font-weight-100 white">
                            <slot name="text"></slot>
                        </h6>
                        <button v-if="!needsForm" @click.stop="goToPage('suppliersPage')" class="axil-btn btn-borderd btn-primary rg-style-button-inline p-4">Conoce más</button>
                        <a v-else href="#" class="axil-btn btn-borderd btn-primary rg-style-button-inline p-4">Conoce más</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "Teams",
    props: ["logo", "needsForm"],
    components: {
    },
    data() {
        return {
            logo_base: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-"
        }
    }
}

</script>

<style scoped>
#teams {
    z-index: 0 !important;
    top: -5rem;
}

@media only screen and (max-width: 991px) {
    .section {
        z-index: 0 !important;
        top: 0;
        margin-top: 3rem;
    }
}

.btn-fill-white {
    border: none;
}

.project-add-banner {
    width: 100%;
    /* background-image: url("https://cdn.redgirasol.com/green/BANNERS/banner-redgirasol-1.jpg") !important; */
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 2rem;
}
</style>